import ninjaApi from 'store/redux/apis/ninja.api';

export const emailConfirmationApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['General', 'DefaultWorkspace', 'User'],
  endpoints: (builder) => ({
    sendMailConfirmation: builder.mutation({
      query: (body) => ({
        url: '/setup/send-confirm-email',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['DefaultWorkspace', 'User'],
    }),

    confirmEmail: builder.mutation({
      query: (body) => ({
        url: '/setup/confirm-email',
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['DefaultWorkspace', 'User'],
    }),
  }),
});

export const { useSendMailConfirmationMutation, useConfirmEmailMutation } = emailConfirmationApi;
